module Client.DomainTypes.PhysicalSensorList

type PhysicalSensorModelOption =
    | LHT65
    | LSN50v2_S31
    | S31_LS
    | S31_LB
    | LSE01
    | SE01_LS
    | SE01_LB
    | LSN50v2_Rain_01mm
    | LSN50v2_Rain_02mm
    | LSN50v2_Wind
    | SN50v3_LS_Rain_01mm
    | SN50v3_LB_Rain_01mm
    | SN50v3_LS_Rain_02mm
    | SN50v3_LB_Rain_02mm
    | SN50v3_LS_Wind
    | SN50v3_LB_Wind
    | LLMS01
    | LSPH01
    | SPH01_LB
    | SPH01_LS
    | WSC1L
    | DDS20_LB
    | DDS20_LS
    | RS485_LB_ZFS_02
    | RS485_LS_ZFS_02
    | SE0X_LB
    | PS_LB
    | PS_LS
    | LDDS75
    | DDS75_LB
    | DDS75_LS
    | WQS_LB
    | WQS_LS

let sensorModelOptionToString sensorType =
    match sensorType with
    | LHT65 -> "Luftsensor (LHT65)"
    | LSN50v2_S31 -> "Luftsensor (LSN50v2_S31)"
    | S31_LS -> "Luftsensor Solar (S31_LS)"
    | S31_LB -> "Luftsensor Batterie (S31_LB)"
    | LSE01 -> "Bodensensor (LSE01)"
    | SE01_LS -> "Bodensensor Solar (SE01_LS)"
    | SE01_LB -> "Bodensensor Batterie (SE01_LB)"
    | LSN50v2_Rain_01mm -> "Regensensor 0,1mm (LSN50v2)"
    | LSN50v2_Rain_02mm -> "Regensensor 0,2mm (LSN50v2)"
    | SN50v3_LS_Rain_01mm -> "Regensensor 0,1mm Solar (SN50v3_LS)"
    | SN50v3_LS_Rain_02mm -> "Regensensor 0,2mm Solar (SN50v3_LS)"
    | SN50v3_LB_Rain_01mm -> "Regensensor 0,1mm Batterie (SN50v3_LB)"
    | SN50v3_LB_Rain_02mm -> "Regensensor 0,2mm Batterie (SN50v3_LB)"
    | LSN50v2_Wind -> "Wind Durchschnitt (LSN50v2)"
    | SN50v3_LS_Wind -> "Wind Durchschnitt Solar (SN50v2_LS)"
    | SN50v3_LB_Wind -> "Wind Durchschnitt Batterie (SN50v2_LB)"
    | LLMS01 -> "Blattnässe (LLMS01)"
    | LSPH01 -> "PH-Wert (LSPH01)"
    | SPH01_LB -> "PH-Wert Batterie (SPH01-LB)"
    | SPH01_LS -> "PH-Wert Solar (SPH01-LS)"
    | WSC1L -> "Wetterstation (WSC1-L)"
    | DDS20_LS -> "Ultraschall Füllstand Solar (DDS20_LS)"
    | DDS20_LB -> "Ultraschall Füllstand Batterie (DDS20_LB)"
    | RS485_LB_ZFS_02 -> "Globalstrahlung Batterie (RS485_LB ZFS_02)"
    | RS485_LS_ZFS_02 -> "Globalstrahlung Solar (RS485_LS ZFS_02)"
    | SE0X_LB -> "4-fach Bodensensor Batterie (SE0x-LB)"
    | PS_LB -> "Drucksensor Batterie (PS_LB)"
    | PS_LS -> "Drucksensor Solar (PS_LS)"
    | LDDS75 -> "Distanz Sensor (LDDS75)"
    | DDS75_LB -> "Distanz Sensor Batterie (DDS75-LB)"
    | DDS75_LS -> "Distanz Sensor Solar (DDS75-LS)"
    | WQS_LB -> "Wasser Qualität Sensor Batterie (WQS_LB)"
    | WQS_LS -> "Wasser Qualität Sensor Solar (WQS_LS)"

let optionFromString optionString =
    match optionString with
    | "Luftsensor (LHT65)" -> Some LHT65
    | "Luftsensor (LSN50v2_S31)" -> Some LSN50v2_S31
    | "Luftsensor Solar (S31_LS)" -> Some S31_LS
    | "Luftsensor Batterie (S31_LB)" -> Some S31_LB
    | "Bodensensor (LSE01)" -> Some LSE01
    | "Bodensensor Solar (SE01_LS)" -> Some SE01_LS
    | "Bodensensor Batterie (SE01_LB)" -> Some SE01_LB
    | "Regensensor 0,1mm (LSN50v2)" -> Some LSN50v2_Rain_01mm
    | "Regensensor 0,2mm (LSN50v2)" -> Some LSN50v2_Rain_02mm
    | "Regensensor 0,1mm Solar (SN50v3_LS)" -> Some SN50v3_LS_Rain_01mm
    | "Regensensor 0,2mm Solar (SN50v3_LS)" -> Some SN50v3_LS_Rain_02mm
    | "Regensensor 0,1mm Batterie (SN50v3_LB)" -> Some SN50v3_LB_Rain_01mm
    | "Regensensor 0,2mm Batterie (SN50v3_LB)" -> Some SN50v3_LB_Rain_02mm
    | "Wind Durchschnitt Solar (SN50v2_LS)" -> Some SN50v3_LS_Wind
    | "Wind Durchschnitt Batterie (SN50v2_LB)" -> Some SN50v3_LB_Wind
    | "Blattnässe (LLMS01)" -> Some LLMS01
    | "PH-Wert (LSPH01)" -> Some LSPH01
    | "Wind Durchschnitt (LSN50v2)" -> Some LSN50v2_Wind
    | "Wetterstation (WSC1-L)" -> Some WSC1L
    | "Ultraschall Füllstand Solar (DDS20_LS)" -> Some DDS20_LS
    | "Ultraschall Füllstand Batterie (DDS20_LB)" -> Some DDS20_LB
    | "Globalstrahlung Batterie (RS485_LB ZFS_02)" -> Some RS485_LB_ZFS_02
    | "Globalstrahlung Solar (RS485_LS ZFS_02)" -> Some RS485_LS_ZFS_02
    | "4-fach Bodensensor Batterie (SE0x-LB)" -> Some SE0X_LB
    | "Drucksensor Batterie (PS_LB)" -> Some PS_LB
    | "Drucksensor Solar (PS_LS)" -> Some PS_LS
    | "PH-Wert Batterie (SPH01-LB)" -> Some SPH01_LB
    | "PH-Wert Solar (SPH01-LS)" -> Some SPH01_LS
    | "Distanz Sensor (LDDS75)" -> Some LDDS75
    | "Distanz Sensor Batterie (DDS75-LB)" -> Some DDS75_LB
    | "Distanz Sensor Solar (DDS75-LS)" -> Some DDS75_LS
    | "Wasser Qualität Sensor Batterie (WQS_LB)" -> Some WQS_LB
    | "Wasser Qualität Sensor Solar (WQS_LS)" -> Some WQS_LS
    | _ -> None

type PressureProbeOption =
    | WaterDepth
    | Pressure